module.exports = __webpack_public_path__ + "img/testimonial-2.f179d317.jpg";